/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiCostcentersMutationRequest,
  PostApiCostcentersMutationResponse,
} from '../models/PostApiCostcenters.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  postApiCostcentersMutationResponseSchema,
  postApiCostcentersMutationRequestSchema,
} from '../zod/postApiCostcentersSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiCostcentersMutationKey = () =>
  [{ url: '/api/costCenters' }] as const;

export type PostApiCostcentersMutationKey = ReturnType<
  typeof postApiCostcentersMutationKey
>;

/**
 * {@link /api/costCenters}
 */
export async function postApiCostcenters(
  data: PostApiCostcentersMutationRequest,
  config: Partial<RequestConfig<PostApiCostcentersMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = postApiCostcentersMutationRequestSchema.parse(data);
  const res = await request<
    PostApiCostcentersMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiCostcentersMutationRequest
  >({
    method: 'POST',
    url: `/api/costCenters`,
    data: requestData,
    ...requestConfig,
  });
  return postApiCostcentersMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/costCenters}
 */
export function usePostApiCostcenters<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiCostcentersMutationResponse,
      ResponseErrorConfig<Error>,
      { data: PostApiCostcentersMutationRequest },
      TContext
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig<PostApiCostcentersMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiCostcentersMutationKey();

  return useMutation<
    PostApiCostcentersMutationResponse,
    ResponseErrorConfig<Error>,
    { data: PostApiCostcentersMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postApiCostcenters(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
